"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var promisifier_1 = require("./promisifier");
Object.defineProperty(exports, "promisify", { enumerable: true, get: function () { return promisifier_1.promisify; } });
//# sourceMappingURL=index.js.map